import { Component } from '@angular/core';

import { AbstractHeaderComponent, BaseHeaderComponent } from '@camelot/core';

import { CamAmountComponent } from '../../amount/amount.component';

@Component({
  host: { 'data-cid': 'grid-billing-amount-header-cell' },
  imports: [BaseHeaderComponent, CamAmountComponent],
  selector: '',
  template: `<cam-ag-grid-base-header class="ml-a" [params]="this.params">
    <cam-billing-amount style="line-height: normal;" display="label"></cam-billing-amount>
  </cam-ag-grid-base-header>`,
})
export class GridBillingAmountHeaderCellComponent extends AbstractHeaderComponent<unknown, any> {}
